<template>
  <li v-if="category.active" class="my-1">
    <div
      class="flex w-full cursor-pointer items-center justify-between px-4 py-2 text-sm text-gray-500 hover:bg-gray-10"
      :class="{
        'bg-gray-10 ': props.active.id === props.category.id,
      }"
      @click="toggle"
    >
      <NuxtLink
        :to="getCategoryRoute(category)"
        class="w-full"
        :class="[
          category.childCount > 0 || isActive ? 'font-bold' : 'font-medium',
        ]"
      >
        <span v-html="getTranslatedProperty(category, 'name')" />
        {{ category.parent }}
      </NuxtLink>
      <template v-if="hasChildren">
        <IconAngleUp v-if="isOpen" class="size-3" />
        <IconAngleDown v-else class="size-3" />
      </template>
    </div>
    <ul v-if="hasChildren && isOpen">
      <li v-for="child in getChildren(category)" :key="child.id" class="my-1">
        <ClientOnly>
          <NuxtLink
            v-if="child.active"
            :to="getCategoryRoute(child)"
            class="block px-8 py-2 text-sm text-gray-500 hover:bg-gray-10"
            :class="{
              'font-medium': child.id !== active.id,
              'bg-gray-10 font-bold': child.id === active.id,
            }"
            v-html="getTranslatedProperty(child, 'name')"
          />
        </ClientOnly>
      </li>
    </ul>
  </li>
</template>

<script setup lang="ts">
import { getTranslatedProperty } from '@shopware/helpers'
import type { Schemas } from '#shopware'

const props = defineProps<{
  category: Schemas['Category']
  active: Schemas['Category']
}>()

const { getCategoryRoute } = useShopRouter()

const childrenToggle = ref(false)

const isActive = computed(
  () =>
    props.active?.id === props.category.id ||
    props.active?.parentId === props.category.id
)

const isOpen = computed(() => {
  if (childrenToggle.value) {
    return true
  }
  return isActive.value
})

const toggle = () => {
  childrenToggle.value = !childrenToggle.value
}

const hasChildren = computed(() => props.category.childCount > 0)

const getChildren = (category: Schemas['Category']) => {
  const children = category.children as Schemas['Category'][]
  const sorted = []
  let current = children?.find((child) => !child.afterCategoryId)
  while (current) {
    sorted.push(current)
    current = children?.find((child) => child.afterCategoryId === current?.id)
  }
  return sorted
}
</script>
